import { render, staticRenderFns } from "./result_union.vue?vue&type=template&id=90f7f860&scoped=true"
import script from "./result_union.vue?vue&type=script&lang=js"
export * from "./result_union.vue?vue&type=script&lang=js"
import style0 from "./result_union.vue?vue&type=style&index=0&id=90f7f860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f7f860",
  null
  
)

export default component.exports